import { useSubgraphClient } from 'index'
import { PoolType } from 'pages/Liquidity/hooks/usePool'
import { useEffect, useState } from 'react'
import { useSetSnapshotData, useSnapshotState } from 'state/islandSnapshots/hooks/useSetSnapshotData'

import { transformV2DataToSnapshot, V2_SNAPSHOT_QUERY } from './useSubgraphSnapshotsV2'
import { SNAPSHOT_QUERY } from './useSubgraphSnapshotsV3'

export const usePoolSnapshots = (poolAddress: string, poolType: PoolType) => {
  const { setSnapshots, setLoading } = useSetSnapshotData()
  const apolloClient = useSubgraphClient('v3')
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!poolAddress || !poolType) {
      return
    }

    setError(null)

    setLoading(poolAddress, true)

    const query = poolType === 'V2' ? V2_SNAPSHOT_QUERY : SNAPSHOT_QUERY
    const variables =
      poolType === 'V2' ? { poolId: poolAddress.toLowerCase() } : { islandId: poolAddress.toLowerCase() }

    apolloClient
      .query({ query, variables, fetchPolicy: 'network-only' })
      .then((response) => {
        const data =
          poolType === 'V2'
            ? response.data?.pairDayDatas?.map(transformV2DataToSnapshot)
            : response.data?.kodiakVaultDailySnapshots

        if (data && Array.isArray(data)) {
          setSnapshots(poolAddress, data)
        } else {
          setSnapshots(poolAddress, [])
        }

        setLoading(poolAddress, false)
      })
      .catch((error) => {
        console.error(`Error fetching snapshots for ${poolAddress}:`, error)
        setError(error)
        setLoading(poolAddress, false)
      })

    return () => {
      // Clean up when component unmounts or dependencies change
      setSnapshots(poolAddress, [])
    }
  }, [apolloClient, poolAddress, poolType, setLoading, setSnapshots])

  const snapshotState = useSnapshotState(poolAddress)

  return {
    ...snapshotState,
    error,
    isValid: Boolean(poolAddress && poolType),
    requestedPool: poolAddress,
    requestedType: poolType,
  }
}
